// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-ericswanson-gatsby-theme-donations-src-pages-index-js": () => import("../node_modules/@ericswanson/gatsby-theme-donations/src/pages/index.js" /* webpackChunkName: "component---node-modules-ericswanson-gatsby-theme-donations-src-pages-index-js" */)
}

